import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            <svg class=", " ref=", " xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 163.8 209.4\"><path d=\"M162.4,102.2c1.8,1.2,1.9,3.9,0,5L4.8,208.8c-1.9,1.5-4.8,0.1-4.8-2.4V3c0-2.3,2.6-3.8,4.6-2.5L162.4,102.2z\"/></svg>\n\n            <img class=", " src=\"", "work/", "\" ref=", " @click=", "/>\n            <iframe class=", " ref=", " @load=", "></iframe>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import anime from 'animejs';
import sniffer from 'sniffer';
import { ref } from 'lib/lit-ref';
import * as styles from './styles';
export default class VimeoPlayer extends Component {
  static get properties() {
    return {
      video: Object
    };
  }

  init() {
    this.hasIframe = false;
    this.options.autoDestroy = false;
    this.onVideoEnded = this.onVideoEnded.bind(this);
  }

  render() {
    this.refs = {};
    return html(_templateObject(), styles.icon, ref(this, 'icon'), styles.poster, ENV.assetsURL, this.video.poster, ref(this, 'poster'), sniffer.isIos ? this.playIframe : this.addIframe, styles.player, ref(this, 'player'), this.onIframeLoaded);
  }

  onRender() {
    this.classList.add(styles.vimeo);
    this.loaded = new Promise((resolve, reject) => {
      if (this.refs.poster.complete) resolve();else this.refs.poster.onload = () => {
        this.refs.poster.onload = null;
        resolve();
      };
    });
    if (sniffer.isIos) this.addIframe();
  }

  updated() {
    if (this.hasIframe) {
      anime.remove(this);
      anime({
        targets: this,
        opacity: 0,
        easing: 'easeOutCubic',
        duration: 600,
        complete: () => {
          this.player.pause();
          this.player.unload();
          this.refs.icon.classList.remove('u-hidden');
          this.refs.poster.classList.remove('u-inactive');
          this.refs.poster.classList.remove('u-hidden');
          this.refs.icon.style.opacity = '';
          this.refs.poster.style.opacity = 1;
          this.hasIframe = false;
          anime.remove(this);
          anime({
            targets: this,
            opacity: 1,
            easing: 'easeOutCubic',
            duration: 600,
            delay: 50
          });
          if (sniffer.isIos) this.addIframe();
        }
      });
    } else {
      anime.remove(this);
      anime({
        targets: this,
        opacity: 1,
        easing: 'easeOutCubic',
        duration: 600,
        delay: 200
      });
    }
  }

  get vimeoUrl() {
    let id = this.video.url.split('vimeo')[1].split('/')[1];
    let autoplay = sniffer.isIos ? 0 : 1;
    return "https://player.vimeo.com/video/".concat(id, "?title=0&byline=0&portrait=0&autoplay=").concat(autoplay, "&controls=0");
  }

  addIframe() {
    if (this.hasIframe) return;
    this.hasIframe = true;
    document.body.classList.add('u-loading');
    let iframe = this.refs.player;
    iframe.setAttribute('frameborder', '0');

    if (sniffer.isIos) {
      iframe.setAttribute('allow', 'fullscreen');
    } else {
      iframe.setAttribute('allow', 'autoplay; fullscreen');
    }

    iframe.setAttribute('allowfullscreen', true);
    iframe.setAttribute('src', this.vimeoUrl);

    if (!sniffer.isIos) {
      this.hidePlay();
    }
  }

  playIframe() {
    if (!this.player) return;
    this.hidePlay();
    this.hidePoster();
    this.player.play();
  }

  hidePlay() {
    this.refs.poster.classList.add('u-inactive');
    anime({
      targets: this.refs.icon,
      opacity: 0,
      duration: 400,
      easing: 'easeOutQuart',
      complete: () => {
        this.refs.icon.classList.add('u-hidden');
      }
    });
  }

  hidePoster() {
    document.body.classList.remove('u-loading');
    anime({
      targets: this.refs.poster,
      opacity: 0,
      duration: 400,
      easing: 'easeOutQuart',
      complete: () => {
        this.refs.poster.classList.add('u-hidden');
      }
    });
  }

  onVideoEnded() {
    this.updated();
  }

  onIframeLoaded() {
    let src = this.refs.player.getAttribute('src');
    if (!src) return;
    let iframe = this.refs.player;
    this.player = new Vimeo.Player(iframe);
    this.player.off('ended', this.onVideoEnded);
    this.player.on('ended', this.onVideoEnded);
    if (!sniffer.isIos) this.hidePoster();
  }

  animateIn(params, complete) {
    anime({
      targets: this,
      opacity: [0, 1],
      easing: 'easeOutQuart',
      duration: 300,
      complete
    });
  }

  animateOut(params, complete) {
    anime({
      targets: this,
      opacity: 0,
      easing: 'easeOutQuart',
      duration: 300,
      complete
    });
  }

  onDestroy() {
    if (this.player) {
      this.player.off('ended', this.onVideoEnded);
      this.player.pause();
      this.player.destroy();
    }
  }

}
customElements.define('rv-vimeo', VimeoPlayer);